import React, { useState } from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox,
} from "@mui/material";
import Button from "../../components/Button/Button";
import { Save } from "@mui/icons-material";
import {
  change_admin_password,
  edit_admin_role,
  get_admin_detail,
  get_role,
  reset_password_with_key,
  superadmin_change_password,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import toast from "react-simple-toasts";

export default function ChangePassword() {
  const classes = useStyles();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const [sort, setSort] = React.useState(0);
  // const [page, setPage] = useState("User Information");
  const [roleList, setRoleList] = React.useState(null);
  const [selectedRole, setSelectedRole] = React.useState("");

  const handleChangeSort = (event) => {
    setSort(event.target.value);
  };

  const [searchKey, setSearchKey] = React.useState("");
  const handleSearch = (event) => {
    setSearchKey(event.target.value);
  };

  const [totalList, setTotalList] = React.useState(1);
  // const [pageNum, setPageNum] = React.useState(0);

  const [loading, setLoading] = React.useState(false);
  const [adminDetail, setAdminDetail] = React.useState(null);
  const [adminHistory, setAdminHistory] = React.useState(null);

	
  const [token, setToken] = React.useState([]);

  React.useEffect(() => {
    let token = window.localStorage.getItem("token");
    setToken(token || "");
    console.log("CURRENT TOKEN", token);
  }, []);



  // const getData = () => {
  //   setLoading(true);
  //   get_admin_detail({
  //     admin_id: params.admin_id,
  //     // sort: sort
  //   }).then((json) => {
  //     setLoading(false);
  //     setAdminDetail(json.data);
  //     setSelectedRole(json.data.role_id);
  //     // setTotalList(json.total);
  //   });
  //   get_role({}).then((resRole) => {
  //     setRoleList(resRole.data);
  //   });
  // };
  const [password, setPassword] = useState({
		authentication_key: "",
		email:"",
    password: "",
    password_confirm: "",
  });

  const handleChange = (e) => {
    setPassword({
      ...password,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangePassword = () => {
		if (password.authentication_key.length === 0) {
      toast("Please enter authentication key");
      return;
    }
		if (password.email.length === 0) {
      toast("Please enter email");
      return;
    }
    if (password.password.length === 0) {
      toast("Please enter new password");
      return;
    }
    if (password.password_confirm.length === 0) {
      toast("Please enter new confirm password");
      return;
    }
    var data = {
      ...password,
			// token: token
      // admin_id: params.admin_id,
    };
    reset_password_with_key(data).then((json) => {
      if (json.status) {
        toast("Password Changed");
      } else {
        toast(json.message);
      }
    });
  
  };

  // React.useEffect(() => {
  //   getData();
  // }, []);

 

  return (
    <React.Fragment>
      <Navbar2
        children={
          <Section pd="2rem">
            <div>
              <div className={classes.theFlexHeader}>
                <Paragraph color="#000" bold="600" size="24px">
                  Change Password
                </Paragraph>
              </div>
              <div
                style={{
                  borderBottom: "2px solid #707070",
                  padding: ".2rem 0",
                }}
              />
              <br />

              <br />

              <Card className={classes.theCard_}>
                <div className={classes.theCHeader}>
                  <Paragraph
                    color="#000"
                    bold="600"
                    size="16px"
                    // margin="0 0 1rem"
                  >
                    Change Password
                  </Paragraph>
                </div>
                <div className={classes.theCBody}>
                  <Grid container spacing={3} sx={{ alignItems: "baseline" }}>
                    <Grid item xs={12} sm={4} md={2}>
                      <Paragraph size="14px">Authentication Key :</Paragraph>
                    </Grid>
                    <Grid item xs={12} sm={8} md={10}>
                      <FormInput
                        // label='New Password*'
                        textcolor="#707070"
                        placeholder="Authentication Key"
                        name="authentication_key"
                        bg="#fff"
                        border="1px solid #c5c5c5"
                        // type="password"
                        onChange={handleChange}
                        margin="0"
                      ></FormInput>
                    </Grid>
										<Grid item xs={12} sm={4} md={2}>
                      <Paragraph size="14px">Email :</Paragraph>
                    </Grid>
                    <Grid item xs={12} sm={8} md={10}>
                      <FormInput
                        // label='New Password*'
                        textcolor="#707070"
                        placeholder="Email"
                        name="email"
                        bg="#fff"
                        border="1px solid #c5c5c5"
                        // type="password"
                        onChange={handleChange}
                        margin="0"
                      ></FormInput>
                    </Grid>
                    <Grid item xs={12} sm={4} md={2}>
                      <Paragraph size="14px">New Password :</Paragraph>
                    </Grid>
                    <Grid item xs={12} sm={8} md={10}>
                      <FormInput
                        // label='New Password*'
                        textcolor="#707070"
                        placeholder="New Password"
                        name="password"
                        bg="#fff"
                        border="1px solid #c5c5c5"
                        type="password"
                        onChange={handleChange}
                        margin="0"
                      ></FormInput>
                    </Grid>
                    <Grid item xs={12} sm={4} md={2}>
                      <Paragraph size="14px">Confirm New Password :</Paragraph>
                    </Grid>
                    <Grid item xs={12} sm={8} md={10}>
                      <FormInput
                        textcolor="#707070"
                        placeholder="Confirm New Password"
                        name="password_confirm"
                        bg="#fff"
                        border="1px solid #c5c5c5"
                        type="password"
                        onChange={handleChange}
                        margin="0"
                      ></FormInput>
                    </Grid>
                  </Grid>

                  <div
                    className={classes.theFlexBtn}
                    style={{ marginBottom: "0" }}
                  >
                    <React.Fragment>
                      <a
                        style={{ backgroundColor: "#1A8649" }}
                        className={classes.theCustomActionBtnFill}
                        onClick={() => handleChangePassword()}
                      >
                        <Save sx={{ color: "#fff" }} />
                        <Paragraph margin="0 0 0 .4rem">Save</Paragraph>
                      </a>
                    </React.Fragment>
                  </div>
                </div>
              </Card>
              <br />
              <br />
            </div>
          </Section>
        }
      />
    </React.Fragment>
  );
}
